<template>
    <v-navigation-drawer style="z-index: 2" fixed v-model="dialog" right temporary height="100vh" width="400">
        <v-card tile flat>

            <v-app-bar color="white" flat>
                <v-btn icon @click="hide">
                    <v-icon color="secondary">mdi-close</v-icon>
                </v-btn>
                <v-spacer/>
                <div class="app-title">
                    {{ $t('common.config') }}
                </div>
                <v-spacer/>
            </v-app-bar>

            <v-list-item link @click="editBasicInfo">
                <v-list-item-title>
                    {{ $t('student.edit_basic_info') }}
                </v-list-item-title>
            </v-list-item>
            <v-divider class="mx-4"></v-divider>

            <v-list-item link @click="editProfesionalInfo">
                <v-list-item-title>
                    {{ $t('common.edit_professional_info') }}
                </v-list-item-title>
            </v-list-item>
            <v-divider class="mx-4"></v-divider>

            <v-list-item @click="toSelectPlan" link v-if="showPlanOptions">
                <v-list-item-title>
                    {{ $t('entrance.change_plan') }}
                </v-list-item-title>
            </v-list-item>
            <v-divider class="mx-4" v-if="showPlanOptions"/>

            <v-list-item @click="toPaymentMethod" link v-if="showPlanOptions">
                <v-list-item-title>
                    {{ $t('student.payment_method') }}
                </v-list-item-title>
            </v-list-item>
            <v-divider class="mx-4" v-if="showPlanOptions"/>

            <v-list-item link @click="$emit('click:cancel-subscription')"
                         v-if="showSubscriptionCancel && showPlanOptions">
                <v-list-item-title>
                    {{ $t('coach.cancel_subscription') }}
                </v-list-item-title>
            </v-list-item>
            <v-divider class="mx-4" v-if="showSubscriptionCancel && showPlanOptions"/>

            <v-list-item @click="logout" link>
                <v-list-item-title>
                    {{ $t('entrance.logout') }}
                </v-list-item-title>
            </v-list-item>

        </v-card>
    </v-navigation-drawer>
</template>

<script>

import {mapState, mapMutations} from 'vuex'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    props: {
        showSubscriptionCancel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false
        }
    },
    methods: {
        ...mapMutations(['reset', 'cleanDataStorage', 'setDialogActive']),
        show() {
            var vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            var vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
        async logout() {
            const vm = this
            await firebase.auth().signOut()
            await vm.$router.replace({name: 'login'})
        },
        toSelectPlan() {
            const vm = this
            vm.hide()
            vm.$router.push({name: 'company.profile.edit', params: {mode: 'SelectPlan'}})
        },
        toPaymentMethod() {
            const vm = this
            vm.hide()
            vm.$router.push({name: 'company.payment.edit'})
        },
        editBasicInfo() {
            const vm = this
            vm.hide()
            vm.$router.push({name: 'company.profile.edit', params: { mode: 'BasicInfo' }})
        },
        editProfesionalInfo() {
            const vm = this
            vm.hide()
            vm.$router.push({name: 'company.profile.edit', params: { mode: 'ProfessionalInfo' }})
        },
    },
    computed: {
        ...mapState(['dialogActive']),
        showPlanOptions(vm = this) {
            return !vm.isIphone && vm.account?.accountType === 'company'
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        }
    }
}

</script>

<style scoped>

.app-title {
    color: #333333;
    font-size: 20px;
}

</style>
